import { useExaminationCourse } from '@exam-management/examination-course-details';
import { useQConfig } from '@exam-management/feature-qconfig-provider';
import { Box, Flex, Grid, SectionTitle, Text } from '@shared/components';

export default function ExamOverviewSection() {
  const { examinationCourse } = useExaminationCourse();
  const { qConfigData } = useQConfig();

  const { name: examCourseName } = examinationCourse;
  const { totalQuestions, fullScore } = qConfigData;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(8) }}>
      <SectionTitle title='Exam Overview' />
      <Grid
        sx={(theme) => ({
          gridTemplate: '1fr / 240px 1fr',
          gap: theme.spacing(4, 6),
        })}
      >
        <Box>
          <Text variant='body1Semibold'>หลักสูตรทดสอบ</Text>
        </Box>
        <Box>
          <Text>{examCourseName}</Text>
        </Box>
        <Box>
          <Text variant='body1Semibold'>จำนวนข้อสอบทั้งหมด</Text>
        </Box>
        <Box>
          <Text>{totalQuestions} ข้อ</Text>
        </Box>
        <Box>
          <Text variant='body1Semibold'>คะแนนรวม</Text>
        </Box>
        <Box>
          <Text>{fullScore} คะแนน</Text>
        </Box>
      </Grid>
    </Flex>
  );
}
